/** A comparable form of a note: lowercase ASCII words separated by single spaces. */
export function normalizeNote(note: string | null | undefined): string {
  if (!note) return '';
  return note
    .normalize('NFKD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();
}

export function noteTokens(note: string | null | undefined): string[] {
  const n = normalizeNote(note);
  return n === '' ? [] : n.split(' ').filter((t) => t.length >= 2);
}
